module.exports = __webpack_public_path__ + "img/Group28154@2x.e520b3f3.png";